import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { CompanyUser, UserList, UserLess } from '@models/User';
import { API_V1_BASE } from '@config';
import { snakes } from '@utils/lodash';
import { WithParams } from '@utils/typescript';

export type FindUserParams = WithParams<{
  name: string;
  dob: string;
  gender: string;
}>;

export type SaveUserParams = FindUserParams & WithParams<{
  mobile_number?: string;
  email?: string;
  occupation?: string;
  address?: string;
}>;

export class UserApi {
  static getAllCompanyUsers = async () => {
    return await authAxios
      .get(`${API_V1_BASE}/company_users`)
      .then((response) => humps(response.data) as CompanyUser[]);
  };

  static getAllFrontlineUsers = async () => {
    return await authAxios
      .get(`${API_V1_BASE}/frontline_users`)
      .then((response) => humps(response.data) as UserList[]);
  };

  static getAllServicers = async () => {
    return await authAxios
      .get(`${API_V1_BASE}/servicers`)
      .then((response) => humps(response.data) as UserList[]);
  };

  static find = async (params: FindUserParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/users/find`, { params: snakes(params) })
      .then((response) => humps(response.data) as UserLess);
  }

  static save = async (params: SaveUserParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/users/save`, snakes(params))
      .then((response) => humps(response.data) as UserLess);
  };
}
